import { Container, Row, Col, Card } from "react-bootstrap";

export default function Roadways() {
  return (
    <Container fluid className="py-5 bg-white">
      <h2 className="text-center text-primary fw-bold">Roadways</h2>
      <p className="mt-3 text-center text-secondary fs-5">
        Building world-class road infrastructure to improve connectivity and enable seamless transportation.
      </p>

      <Row className="mt-4 justify-content-center g-4">
        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0">
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Expressways</Card.Title>
              <Card.Text className="text-secondary">
                Developing high-speed expressways for better urban mobility.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0">
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Flyovers & Bridges</Card.Title>
              <Card.Text className="text-secondary">
                Constructing durable bridges and flyovers to ease congestion.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
